import { css } from '@emotion/react';

export const selectButton = css`
  min-width: 100px;
`;
